<template lang="pug">
panel-directory(
  title="Регион"
  :action-type="actionType"
  :api-method="$rApi.directories.getRegions"
  :input-attrs="inputAttrs"
  no-reset
  v-bind="$attrs"
  v-on="$listeners"
)
</template>

<script>
import PanelDirectory from './PanelDirectory.vue';
import { ROW_ACTION_KEY } from '../constants';

export default {
  name: 'PanelRegion',
  components: {
    PanelDirectory,
  },
  data() {
    return {};
  },
  computed: {
    actionType() {
      const { indicate } = ROW_ACTION_KEY;

      return indicate;
    },
    inputAttrs() {
      return {
        placeholder: 'Найти регион',
      };
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
